import React,{ useEffect, useState } from 'react';


function Forbidden403() {
    const [encryptedId, setEncryptedId] = useState('');

    useEffect(() => {
        setEncrypted();
      }, []);

    const setEncrypted = async () =>{
        let id = localStorage.getItem('encryptedId');
        id = JSON.parse(id);
        setEncryptedId(id)
    }     

    return (
        <div style={styles.container}>
            <h1>403 Forbidden</h1>
            <img src={'/403.svg'} alt="403 Forbidden" style={styles.image} />
            <p>You don't have permission to access this page.</p>
            <button style={styles.button} onClick={() => window.location.href=`/customer/entity-dashboard?id=${encryptedId}`}>Go to Dashboard</button>
        </div>
    );
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f3f4f6',
        color: '#333',
        textAlign: 'center',
    },
    image: {
        maxWidth: '30%',
        marginBottom: '1rem',
    },
    button: {
        padding: '10px 20px',
        fontSize: '1rem',
        color: '#fff',
        backgroundColor: '#556ee6',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        marginTop: '1rem',
    }
}

export default Forbidden403;